import React from 'react';
import { classNames } from '../../utils/format';

export default function Card({ title, subtitle, actions, padded = true, className, children }) {
  return (
    <div className={classNames('card', className)}>
      {(title || actions || subtitle) && (
        <div className="card-header">
          <div>
            {title && <div className="card-title">{title}</div>}
            {subtitle && <div className="card-title-sub">{subtitle}</div>}
          </div>
          {actions && <div className="card-header-actions">{actions}</div>}
        </div>
      )}
      <div className={padded ? 'card-body' : ''}>{children}</div>
    </div>
  );
}
